import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'

// TODO: enable StrictMode after fixing https://github.com/ant-design/ant-design/issues/22493
ReactDOM.render(<App />, document.getElementById('app'))
